/**
 * `v3.work.snapshot` — what a member's Work page projects its schedule from: the caller's
 * customer's online `loops` runners and a p50/p90 estimate per queued or running run.
 * Payloads live in `@fm/v3`.
 *
 * A separate group from `V3RunRpcs` so its handler lives in its own router file.
 *
 * Handlers: `v3-work.router.ts`.
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { WorkSnapshot, WorkSnapshotInput } from "@fm/v3";
import { Schema } from "effect";
import { DatabaseError, Forbidden, Unauthorized, ValidationError } from "../errors.ts";
import { LoopActorMiddleware } from "../loop-actor.tags.ts";

/**
 * @since 1.0.0
 */
export class V3WorkRpcs extends RpcGroup.make(
  Rpc.make("v3.work.snapshot", {
    payload: WorkSnapshotInput,
    success: WorkSnapshot,
    error: Schema.Union(Unauthorized, Forbidden, ValidationError, DatabaseError),
  }).middleware(LoopActorMiddleware),
) {}
